import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Switch } from "@/components/ui/switch";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { ImageField } from "./ImageField";

export const EntityForm = ({ fields, form, setForm, prefix }) => {
  const set = (k, v) => setForm((f) => ({ ...f, [k]: v }));
  return (
    <div className="grid sm:grid-cols-2 gap-4">
      {fields.map((f) => {
        const tid = `${prefix}-field-${f.name}`;
        const full = f.type === "textarea" || f.full;
        return (
          <div key={f.name} className={`space-y-1.5 ${full ? "sm:col-span-2" : ""}`}>
            <Label htmlFor={tid}>{f.label}{f.required && <span className="text-red-600"> *</span>}</Label>
            {f.type === "image" && <ImageField value={form[f.name]} onChange={(v) => set(f.name, v)} folder={f.folder} testId={tid} />}
            {f.type === "textarea" && (
              <Textarea id={tid} value={form[f.name] ?? ""} onChange={(e) => set(f.name, e.target.value)} rows={3} data-testid={tid} />
            )}
            {f.type === "select" && (
              <Select value={String(form[f.name] ?? "")} onValueChange={(v) => set(f.name, v)}>
                <SelectTrigger id={tid} data-testid={tid}><SelectValue placeholder="Pilih..." /></SelectTrigger>
                <SelectContent>
                  {f.options.map((o) => (
                    <SelectItem key={o.value} value={o.value} data-testid={`${tid}-option-${o.value}`}>{o.label}</SelectItem>
                  ))}
                </SelectContent>
              </Select>
            )}
            {f.type === "switch" && (
              <div className="flex items-center gap-3 h-10">
                <Switch id={tid} checked={!!form[f.name]} onCheckedChange={(v) => set(f.name, v)} data-testid={tid} />
                <span className="text-sm text-slate-600">{form[f.name] ? "Aktif" : "Nonaktif"}</span>
              </div>
            )}
            {!["textarea", "select", "switch", "image"].includes(f.type) && (
              <Input
                id={tid}
                type={f.type || "text"}
                value={form[f.name] ?? ""}
                onChange={(e) => set(f.name, e.target.value)}
                required={f.required}
                min={f.type === "number" ? 0 : undefined}
                placeholder={f.placeholder}
                data-testid={tid}
              />
            )}
          </div>
        );
      })}
    </div>
  );
};
